import {
    Container,
    Typography,
    Box,
    Stack,
} from "@mui/material";
import React from 'react';
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";
import VideoPreview from "../../components/common/VideoPreview/VideoPreview";

export default function TestVideoPreview() {
    const { t } = useTranslation();
    const [value, setValue ] = React.useState(1234);

    React.useEffect(() => {
        setValue(1234);
    }, []);

    let lang = getLang();

    // setValue(1234);

    return (
        <Container maxWidth="lg">
            <Stack direction="column">
                <Typography variant="h3">Test Video Preview</Typography>


                <Box>
                    <p>Current Lang: {lang}</p>
                    <p>translateText: {t("testing.msg")}</p>
                    <pre>Value: {value} </pre>
                </Box>

                <Box sx={{ mt: 3 }}>
                    <Typography variant="h5" gutterBottom>Normal Video</Typography>
                    <VideoPreview
                        url="https://file-examples.com/storage/fe3da4509a69e750b9332a3/2017/04/file_example_MP4_480_1_5MG.mp4"
                        title="Normal Video Example"
                    />
                </Box>

                <Box sx={{ mt: 3 }}>
                    <Typography variant="h5" gutterBottom>YouTube Video</Typography>
                    <VideoPreview
                        url="https://youtu.be/EngW7tLk6R8?si=gpqoPOtlab_nLDBo"
                        title="YouTube Video Example"
                    />
                </Box>
            </Stack>
        </Container>
    )
}
